import { createAction } from 'redux-actions';
import * as homepageTypes from './homepageTypes';

// export const getHomepage = createRequestActions(homepageTypes.HOMEPAGE);
// export const saveHomepage = createRequestActions(homepageTypes.SAVE_HOMEPAGE);
// export const deleteHomepage = createRequestActions(homepageTypes.DELETE_HOMEPAGE);
export const mergeHomepages = createAction(homepageTypes.MERGE_HOMEPAGES);

// Actions creators
